// extracted by mini-css-extract-plugin
module.exports = {"fix_blinking":"fix_blinking-pJjzb","show_delay":"show_delay-bzQyz"};